"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Group;

var _Popover2 = _interopRequireDefault(require("@material-ui/core/Popover"));

var _Autocomplete2 = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _TextField2 = _interopRequireDefault(require("@material-ui/core/TextField"));

var _ArrowDropDownRounded2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDownRounded"));

var _ButtonGroup2 = _interopRequireDefault(require("@material-ui/core/ButtonGroup"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _IconButton2 = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _CloseRounded2 = _interopRequireDefault(require("@material-ui/icons/CloseRounded"));

var _ListAltRounded2 = _interopRequireDefault(require("@material-ui/icons/ListAltRounded"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../components/Button"));

var _icons = _interopRequireDefault(require("../icons"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      width: 400
    },
    search: {
      borderBottom: "2px solid rgb(0 0 0 / 5%)"
    },
    list: {
      maxHeight: "70vh",
      overflow: "auto"
    },
    button: {
      backgroundColor: "#f3f4f6"
    },
    icon: {
      marginRight: 4,
      fontSize: 20
    },
    iconType: {
      "& svg": {
        fontSize: 16,
        marginRight: 6,
        marginTop: 2
      }
    }
  };
});
Group.propTypes = {
  fields: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    type: _propTypes["default"].string,
    options: _propTypes["default"].object
  })),
  value: _propTypes["default"].object,
  onChange: _propTypes["default"].func
};
Group.defaultProps = {
  fields: [],
  value: {},
  onChange: function onChange() {}
};

function Group(_ref) {
  var fields = _ref.fields,
      value = _ref.value,
      onChange = _ref.onChange;
  var classes = useStyles();

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var options = (0, _react.useMemo)(function () {
    return fields;
  }, [fields]);

  var handleAdd = function handleAdd(e, item) {
    var newValue = _objectSpread({}, value);

    newValue[item.name] = 1;
    onChange(newValue);
  };

  var handleChange = function handleChange(name, sort) {
    var newValue = _objectSpread({}, value);

    newValue[name] = sort;
    console.log(newValue);
    onChange(newValue);
  };

  var handleDelete = function handleDelete(name) {
    var newValue = _objectSpread({}, value);

    delete newValue[name];
    onChange(newValue);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    style: Object.keys(value).length > 0 ? {
      backgroundColor: "#ede2fe"
    } : {},
    onClick: handleClick,
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(_ListAltRounded2["default"], {
    className: classes.icon
  }), Object.keys(value).length > 0 ? "Grouped ".concat(Object.keys(value).length, " field") : "Group"), /*#__PURE__*/_react["default"].createElement(_Popover2["default"], {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    pt: 2,
    px: 2,
    className: classes.list
  }, Object.keys(value).map(function (key, index) {
    var name = key;
    var sort = value[key];
    return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      mb: 1,
      alignItems: "center",
      key: name,
      justifyContent: "space-between",
      display: "flex"
    }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      alignItems: "center",
      display: "flex"
    }, /*#__PURE__*/_react["default"].createElement(_IconButton2["default"], {
      onClick: function onClick() {
        return handleDelete(name);
      },
      size: "small"
    }, /*#__PURE__*/_react["default"].createElement(_CloseRounded2["default"], {
      fontSize: "small"
    })), /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      variant: "body2"
    }, index === 0 ? "Group by" : "Then by", " ", name)), /*#__PURE__*/_react["default"].createElement(_ButtonGroup2["default"], {
      size: "small"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      onClick: function onClick() {
        return handleChange(name, 1);
      },
      color: "primary",
      variant: sort === 1 ? "contained" : "outlined"
    }, "A \u2192 Z"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      onClick: function onClick() {
        return handleChange(name, -1);
      },
      color: "primary",
      variant: sort === -1 ? "contained" : "outlined"
    }, "Z \u2192 A")));
  }), Object.keys(value).length === 0 && /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    mb: 1
  }, /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    variant: "body2",
    color: "textSecondary"
  }, "No groups applied to this view"))), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    pb: 2,
    px: 2
  }, /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
    options: options,
    getOptionLabel: function getOptionLabel(option) {
      return option.name;
    },
    onChange: handleAdd,
    disableClearable: true,
    popupIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null),
    value: {
      name: "Pick a field to group by"
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, {
        fullWidth: true,
        size: "small"
      }));
    },
    renderOption: function renderOption(option) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
        display: "flex"
      }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
        className: classes.iconType
      }, _icons["default"][option.type]), /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
        variant: "body2"
      }, option.name)));
    }
  })))));
}